var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Chart',{attrs:{"useUrl":this.useUrl}})
}
var staticRenderFns = []

export { render, staticRenderFns }